import React, { createContext, useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState('it');
  const [loading, setLoading] = useState(false); // No loading needed

  useEffect(() => {
    // Force Italian only - clear any saved preferences
    localStorage.removeItem('zonepass_language');
    localStorage.setItem('zonepass_language', 'it');
    
    setCurrentLang('it');
    i18n.changeLanguage('it');
    document.documentElement.lang = 'it';
  }, []);

  const changeLanguage = (lang) => {
    setCurrentLang(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem('zonepass_language', lang);
    
    // Update HTML lang attribute
    document.documentElement.lang = lang;
    
    // Notify backend about language preference
    try {
      localStorage.setItem('user_preferred_language', lang);
    } catch (error) {
      console.error('Failed to save language preference:', error);
    }
  };

  return (
    <LanguageContext.Provider value={{ currentLang, changeLanguage, loading }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
